export { whiteSpaceValidation } from './whiteSpace';

export const PASSWORD_RGX = /^[A-zА-я0-9!@#$%^&*(){}_+\-=|\\/.,?><`~:;]+$/g;

export const CHARACTERS_IN_INPUT_PHONE = /^[0-9\b]+$/;
export const CHARACTERS_IN_INPUT_SYMBOLS = /^[a-zA-ZА-Яа-я\b]$/;
export const ENTERING_SPACES = /^((?!\s{2}).)*$/;
export const BELARUS_NUMBER = /^(375|80)(\d{2})(\d{3})(\d{2})(\d{2})$/;
export const CHARACTERS_IN_INPUT_SYMBOLS_USER = /^[a-zA-ZА-Яа-я]+( [a-zA-ZА-Яа-я]+)* ?$/;
